/** Checks if a string contains markdown or not.
 * # Note
 * This assumes that a lone block of text ( a string with just a paragraph) is not markdown.
 */
export function hasMarkdown(text: string) {
  // eslint-disable-next-line no-useless-escape
  return /^[#|\-|\*|\[|>]|^\d\./gm.test(text);
}
